// apiService.js
import { ROUTE_PATHS } from "@/router/constants";
import axios from "axios";
import { StatusCodes } from "http-status-codes";
import { performTokenRefresh, clearAuthTokens } from "@/utils/tokenUtils.js";

// Environment URL setup
let envURL = import.meta.env.VITE_BASE_URL;
const host = window.location.host;
const parts = host.split(".");
if (parts[0] === "demo") {
  envURL = "https://demo.api.lved.com";
}

export const BaseURL = envURL;

const handleUnauthorizedError = (instance) => {
  instance.interceptors.response.use(
    (response) => response,
    async (error) => {
      if (
        error?.response?.status === StatusCodes.UNAUTHORIZED ||
        error?.response?.status === StatusCodes.INSUFFICIENT_SPACE_ON_RESOURCE
      ) {
        // Try refresh once
        const refreshResult = await performTokenRefresh(BaseURL, 0);
        if (refreshResult.success) {
          const originalRequest = error.config;
          if (!originalRequest._retry) {
            originalRequest._retry = true;
            return instance(originalRequest); // retry without attaching token
          }
        }

        // If refresh failed  clear cookies and redirect
        clearAuthTokens();
        window.location.href = ROUTE_PATHS.LOGIN;
      }
      return Promise.reject(error);
    }
  );
};

const createBaseInstance = (
  baseURL,
  contentType = "application/json",
  withAuth = false
) => {
  const instance = axios.create({
    baseURL,
    headers: { "Content-Type": contentType },
    withCredentials: true, // ensures cookie (access) is sent
  });

  if (withAuth) {
    handleUnauthorizedError(instance);
  }

  return instance;
};

// Export clients
export const authData = createBaseInstance(BaseURL, "application/json", true);
export const nonAuthData = createBaseInstance(
  BaseURL,
  "application/json",
  false
);
export const multipartData = createBaseInstance(
  BaseURL,
  "multipart/form-data",
  false
);
export const multipartDataWithToken = createBaseInstance(
  BaseURL,
  "multipart/form-data",
  true
);
